import {connect} from 'react-redux';
import {Solution as Component} from './Solution';
import {
  createSolution,

  pushInteractions,
  solutionOpen,
  setSolutionInScene,
  setSolutionOnRack,
  setSolution,
  setSolutionHeld,
  setHeldObject,
  setSolutionControlVisibility,

  //addTubeToCentrifuge,
  //setSolutionTubesInCentrifuge,
  setSolutionOnIce,
  addTubeToHeatBlock,
  addTubeToIceBucket,
  removeTubeFromIceBucket,
  addTubeToThermocycler,
  removeTubeFromThermocycler,

  setThermocyclerControlVisibility,

  setMoveMenu,
  showMoveMenu,

  hideAllControls,
  addTubeToRack,

  setShowSolutionContents,

  //onTubeDropHB, d
  //onMicrocentrifugeInsertItem,
  //onItemDropCentrifugeMC,

} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("solutions") &&
     state.notebook.protocolSection.scene.apparatus.solutions.some(
       solution => solution.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      open: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id-1].open,
      type: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id-1].type,

      size: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id-1].size,

      fullName: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id-1].fullName,
      inScene: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id-1].inScene,
      onRack: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id-1].onRack,
      onIce: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id-1].onIce,
      volume: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id-1].volume,
      controlsVisible: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id-1].controlsVisible,
      solutionAlias: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id - 1].solutionAlias,
      renamable: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id - 1].renamable,
      labelReactionTubes: state.notebook.protocolSection.scene.labelReactionTubes,
      interactionProps: {
        microcentrifuge: state.notebook.protocolSection.scene.apparatus.microcentrifuge,
        heatBlocks: state.notebook.protocolSection.scene.apparatus.heatBlocks,
        iceBuckets: state.notebook.protocolSection.scene.apparatus.iceBuckets,
        solutions: state.notebook.protocolSection.scene.apparatus.solutions,
        floatingTubeRack: state.notebook.protocolSection.scene.apparatus.floatingTubeRack,
      },
      showSolutionContents: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id - 1].showSolutionContents,
      levelSelected: state.notebook.levelSelected
      //moveMenuDisplay: state.moveMenu.display,
    }
  } else {
    return {
      levelSelected: state.notebook.levelSelected
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createSolution: (data) => {
      dispatch(createSolution(data))
    },
    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },
    solutionOpen: (data) => {
      dispatch(solutionOpen(data))
    },
    setSolutionInScene: (data) => {
      dispatch(setSolutionInScene(data))
    },
    setSolutionOnRack: (data) => {
      dispatch(setSolutionOnRack(data))
    },
    setSolution: (data) => {
      dispatch(setSolution(data))
    },
    setSolutionHeld: (data) => {
      dispatch(setSolutionHeld(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    setSolutionControlVisibility: (data) => {
      dispatch(setSolutionControlVisibility(data))
    },
    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    setSolutionOnIce: (data) => {
      dispatch(setSolutionOnIce(data))
    },
    addTubeToHeatBlock: (data) => {
      dispatch(addTubeToHeatBlock(data))
    },
    addTubeToIceBucket: (data) => {
      dispatch(addTubeToIceBucket(data))
    },
    addTubeToRack: (data) => {
      dispatch(addTubeToRack(data))
    },
    removeTubeFromIceBucket: (data) => {
      dispatch(removeTubeFromIceBucket(data))
    },
    addTubeToThermocycler: (data) => {
      dispatch(addTubeToThermocycler(data))
    },
    removeTubeFromThermocycler: (data) => {
      dispatch(removeTubeFromThermocycler(data))
    },
    setThermocyclerControlVisibility: (data) => {
      dispatch(setThermocyclerControlVisibility(data))
    },
    setShowSolutionContents: (data) => {
      dispatch(setShowSolutionContents(data))
    },
    // onTubeDropHB: (data) => {
    //   dispatch(onTubeDropHB(data))
    // },
    // onItemDropCentrifugeMC: (data)=>{
    //   dispatch(onItemDropCentrifugeMC(data))
    // },
    // onMicrocentrifugeInsertItem: (data) => {
    //   dispatch(onMicrocentrifugeInsertItem(data))
    // },
    // setSolutionTubesInCentrifuge: (data) => {
    //   dispatch(setSolutionTubesInCentrifuge(data))
    // },
    // addTubeToCentrifuge: (data) => {
    //   dispatch(addTubeToCentrifuge(data))
    // },
    showMoveMenu: (data) => {
      dispatch(showMoveMenu(data))
    },
    setMoveMenu: (data) => {
      dispatch(setMoveMenu(data))
    },
  };
}

export const Solution = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
